import React from "react";
import '../css/Footer.css';
import {useNavigate} from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    return (
        <footer className="Footer-container">
            <button className="Footer-button" onClick={() => navigate("/copyright/model")}>
                <p>© copyright </p>
            </button>
            {/*<button className="Footer-button" onClick={() => navigate("/ask")}>*/}
            {/*    <p>문의하기</p>*/}
            {/*</button>*/}
            <button
                className="Footer-button"
                onClick={() => window.open("https://github.com/hugesome/Wegohigh/branches", "_blank")}
            >
                <img src="/git.png" alt="GitHub" style={{marginTop: '5px'}} />
            </button>
        </footer>
    );
}

export default Footer;